export const getTotalQuantity = (inputObject) => {
  let totalQuantity = 0;

  for (const actionType in inputObject) {
    const reasons = inputObject[actionType];
    for (const reason in reasons) {
      const details = reasons[reason];
      if (details.hasOwnProperty("quantity")) {
        totalQuantity += details.quantity;
      }
    }
  }

  return totalQuantity;
};

export const transformData = (
  orderId,
  orderItemId,
  inputObject,
  pickUpDate,
) => {
  const result = [];

  for (const [requestType, requestDetails] of Object.entries(inputObject)) {
    for (const [returnReason, reasonDetails] of Object.entries(
      requestDetails,
    )) {
      const transformedObj = {
        order_id: orderId,
        order_item_id: orderItemId,
        request_type: requestType,
        scheduled_date: pickUpDate || "",
        return_reason: returnReason,
        quantity: reasonDetails.quantity,
        user_comment: reasonDetails.user_comment,
        image_upload: reasonDetails.image_upload.map((img) => img.url),
      };
      result.push(transformedObj);
    }
  }
  return result;
};

export const checkRequiredFields = (requests, rules) => {
  const errors = [];

  const ruleMap = {};
  rules.forEach((rule) => {
    ruleMap[rule.key] = rule;
  });

  requests.forEach((request) => {
    const rule = ruleMap[request.return_reason];
    if (!rule) {
      errors.push(`No rule found for return_reason ${request.return_reason}`);
      return;
    }

    if (
      rule.comment_mandatory &&
      (!request.user_comment || request.user_comment.trim() === "")
    ) {
      errors.push(`${rule.label}: कृपया कॉमेंट डालें`);
    }

    if (
      rule.images_mandatory &&
      (!request.image_upload || request.image_upload.length === 0)
    ) {
      errors.push(`${rule.label}: कृपया फोटो डालें`);
    }
  });

  return errors;
};

export const shouldShowPickUpModal = (
  requests,
  return_window_days,
  replacement_window_days,
  allow_scheduling,
  setPickupDate,
) => {
  let res = false;

  requests.forEach((request, index) => {
    const { request_type, return_reason } = request;
    const shouldShowPickupModal =
      ((request_type === "REFUND" && return_window_days) ||
        (request_type !== "REFUND" && replacement_window_days)) &&
      !setPickupDate &&
      allow_scheduling &&
      !["ITEM_MISSING", "FREE_ITEM_MISSING"].includes(return_reason);

    if (shouldShowPickupModal === true) {
      res = true;
      return;
    }
  });
  return res;
};

// PAYLOAD
//   const orderId = "36881565";
//   const orderItemId = "101939159";
//   const inputObject = {
//     "REFUND": {
//       "DAMAGED_PRODUCT": {
//         "image_upload": [
//           {
//             "source": {
//               "uri": "file:///data/user/0/com.citymall.app.debug/cache/rn_image_picker_lib_temp_85627dda-1d0e-48a1-99da-054c91c7d281.jpg"
//             },
//             "id": "3f9aeac0-450e-11ee-9d10-d98bede1613e",
//             "url": "https://cdn-cmimgopt.citymall.live/cmimgopt-e4b9211b-21e4-4e50-8ac0-440d88ad173e.webp"
//           }
//         ],
//         "user_comment": "aghdhghajsghgashd",
//         "quantity": 1
//       },
//       "EXPIRED_PRODUCT": {
//         "image_upload": [
//           {
//             "source": {
//               "uri": "file:///data/user/0/com.citymall.app.debug/cache/rn_image_picker_lib_temp_f640035b-9e13-4493-b705-7ec928f95e2c.jpg"
//             },
//             "id": "6c32eec0-450e-11ee-9d10-d98bede1613e",
//             "url": "https://cdn-cmimgopt.citymall.live/cmimgopt-68376b49-18e3-4c81-b0ce-859c88bb12ed.webp"
//           }
//         ],
//         "user_comment": "jbasjdjahd asjha sdash asd",
//         "quantity": 1
//       }
//     }
//   };
